'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (props) {
  var otherProps = Object.assign({}, props);
  delete otherProps.id;
  delete otherProps.color;
  return _react2.default.createElement('svg', otherProps, _react2.default.createElement('use', {
    xlinkHref: '#' + props.id,
    style: {
      fill: props.color
    }
  }));
};